import React, { useState, useEffect, useContext } from 'react'
import NumberFormat from 'react-number-format'
import { DetailButtonSmall } from 'pageComponents/Account/orderQuoteShared'
import QuantityInput from 'pageComponents/_common/form/quantityInput'

import Context from 'setup/context'
import { useDebounceValue } from 'pageComponents/_common/helpers/generalHelperFunctions'

const PrecustomizedLengthInput = (props) => {
    const {handleUpdate, cutToLength, precustomLength, setPrecustomLength} = props

    const debouncedDisplayLength = useDebounceValue(precustomLength, 500)

    

    useEffect(() => {
        handleUpdate(debouncedDisplayLength)

    }, [debouncedDisplayLength])
    return(
        <NumberFormat decimalScale={1} type='text' step="0.1" min={ cutToLength.minimumLengthX } max={ cutToLength.maximumLengthX } value={precustomLength??cutToLength.minimumLengthX} onChange={ e => setPrecustomLength(e.target.value)} />
    )
}

export default function PrecustomizedItem({
    item,
    cutToLength,
    cutToLengthMaterial,
    setCustomizerItem,
    isActive,
    setActive,
    handleAddToCart
}) {
    const [quantity, setQuantity] = useState(1)
    const [precustomLength, setPrecustomLength] = useState(150)

    const setQuantityHandler = (qty) => {
        setQuantity(qty)
    }

    const setLengthHandler = (ln) => {
        const selectedCustomizations = item.precustomizedItemCustomizations?.map((customization) => ({
            unitOfMeasure: "MM",
            axis: "X",
            materialItemInvMastUid: cutToLengthMaterial?.invMastUid,
            customizationKind: "Miter",
            customizedItem: {
                invMastUid: customization.customizationInvMastUid
            }
        })) ?? []

        setCustomizerItem(customizerItem => {

            const oldCutToLength = customizerItem.customizations.find(c => c.customizationKind === 'CutToLength')
            oldCutToLength["dimLengthX"] = parseFloat(ln)
            return {...customizerItem, customizations: [...selectedCustomizations, oldCutToLength]}

        })
    }

    return(
        <tr onClick={() => {setActive(); setLengthHandler(precustomLength)}}>
            <td>{item.iconMediaPath && <img src={'https://' + item.iconMediaPath} />}</td>
            <td>{item.shortDesc}</td>
            <td> 
                <PrecustomizedLengthInput precustomLength={precustomLength} setPrecustomLength={setPrecustomLength} handleUpdate={setLengthHandler} cutToLength={cutToLength} />
            </td>
            <td>
                <QuantityInput 
                    quantity={quantity}
                    handleUpdate={setQuantityHandler} 
                />
            </td>
            <td className='precustom-add'><DetailButtonSmall onClick={handleAddToCart} disabled={!(isActive)}>Add To Cart</DetailButtonSmall></td>
        </tr>
    )
}